module.exports = __webpack_public_path__ + "static/media/workingmemory-words-8.9059ca66.mp3";